import { jsx as e } from "react/jsx-runtime";
import { forwardRef as h } from "react";
import { SearchField as l } from "./index.es39.js";
import { InputField as c } from "./index.es37.js";
import { SearchIcon as u } from "./index.es325.js";
import { onKeyDownEnter as s } from "./index.es500.js";
const x = h(
  ({ disabled: r, inputType: a, testId: t, setValue: n, onClick: o, onBlur: i, ...m }, f) => {
    const p = (d) => {
      s(d, o);
    };
    return a === "searchfield" ? /* @__PURE__ */ e(
      l,
      {
        ...m,
        ref: f,
        onChange: n,
        onClick: o,
        testId: `${t}-search-field`,
        onBlur: i
      }
    ) : /* @__PURE__ */ e(
      c,
      {
        ...m,
        ref: f,
        testId: `${t}-search-field`,
        onBlur: i,
        onChange: n,
        onClick: o,
        onKeyDown: p,
        RightIcon: /* @__PURE__ */ e(
          u,
          {
            color: r ? "outline" : "blue",
            outline: r ? "disabled" : "default-gray"
          }
        )
      }
    );
  }
);
export {
  x as AutoCompleteInput
};
//# sourceMappingURL=index.es2366.js.map
